import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useWorkspace } from "../store/WorkspaceContext";

const RETRY_MS = [5000, 8000, 12000, 20000, 30000, 45000];

// After a clean-up upgrade the server answers a vehicle open from the previous cache (`clean_pending`) and re-cleans in the
// background. Keep asking for a couple of minutes and swap the fresh outlines into the roll as they land — the tinter sees the
// corrected pattern without re-opening the vehicle.
export function useOutlineRefresh(forService) {
  const { state, dispatch } = useWorkspace();
  const token = useRef(0), vehicleId = useRef(null), shown = useRef(0);
  vehicleId.current = state.vehicle?.id || null;

  useEffect(() => {
    const n = state.outlinesRefreshed || 0;
    if (n > shown.current) toast.success(`${n - shown.current} outline${n - shown.current === 1 ? "" : "s"} updated to the latest clean-up`, { id: "outline-refresh" });
    shown.current = n;
  }, [state.outlinesRefreshed]);

  const watch = (vehicle, svc, patterns) => {
    const t = ++token.current;
    if (!patterns.some((x) => x.clean_pending)) return;
    const tick = (attempt) => {
      if (attempt >= RETRY_MS.length) return;
      setTimeout(async () => {
        if (t !== token.current || vehicleId.current !== vehicle.id) return;
        try {
          const list = forService(await api.patterns(vehicle.id), svc);
          dispatch({ type: "REFRESH_OUTLINES", patterns: list });
          if (list.some((x) => x.clean_pending)) tick(attempt + 1);
        } catch { tick(attempt + 1); }
      }, RETRY_MS[attempt]);
    };
    tick(0);
  };
  return watch;
}
